// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/js/layer/need/layer.css
// module id = J8Iu
// module chunks = 65